import request from '@/config/axios'

export interface O2oDisputeVO {
  id?: number
  disputeNo?: string
  orderId?: number
  orderNo?: string
  userId?: number
  userNickname?: string
  providerId?: number
  providerName?: string
  institutionId?: number
  institutionName?: string
  type?: string
  reason?: string
  description?: string
  evidenceUrls?: string[]
  status?: string
  respondDeadline?: Date
  providerResponse?: string
  providerResponseTime?: Date
  arbitratorId?: number
  arbitrateTime?: Date
  verdict?: string
  verdictRemark?: string
  refundAmount?: number
  createTime?: Date
}

/** O2O 纠纷 — /admin-api/o2o/dispute/* */
export const O2oDisputeApi = {
  getPage: async (params: any) => {
    return await request.get<PageResult<O2oDisputeVO[]>>({ url: '/o2o/dispute/page', params })
  },
  get: async (id: number) => {
    return await request.get<O2oDisputeVO>({ url: '/o2o/dispute/get', params: { id } })
  },
  arbitrate: async (data: {
    id: number
    verdict: string
    refundAmount?: number
    verdictRemark?: string
  }) => {
    return await request.put({ url: '/o2o/dispute/arbitrate', data })
  },
  close: async (data: { id: number; verdictRemark: string }) => {
    return await request.put({ url: '/o2o/dispute/close', data })
  }
}
